import {inject, customElement, bindable, bindingMode, PLATFORM} from 'aurelia-framework';
import {EventAggregator} from 'aurelia-event-aggregator';
import keycode from 'keycode';
import {noop} from 'lodash';


@customElement('contact-box')
@inject(Element, EventAggregator)
export class ContactBox {
  @bindable email='';
  @bindable title = '';
  @bindable( {
    defaultBindingMode: bindingMode.twoWay
  } ) selected=false;
  @bindable deleting = noop;
  __deletePressListener: EventListener;
  constructor(private __element: Element, public __ea: EventAggregator) {
  }
  detached() {
    this.removeListener();
  }
  select() {
    this.selected = !this.selected;
    if (this.selected) {
      this.addListener();
    } else {
      this.removeListener();
    }
  }

  addListener() {
    PLATFORM.global.addEventListener('keyup', this.__deletePressListener = (e: KeyboardEvent) => {
      e.stopImmediatePropagation();
      switch (e.keyCode || e.which) {
      case keycode.codes.backspace:
      case keycode.codes.delete:
        this.__ea.publish('DSSB:ea-box-delete-pressed', {event: e});
        break;
      default: // do nothing
      }
    }, true);
  }

  removeListener() {
    if (this.__deletePressListener) {
      PLATFORM.global.removeEventListener('keyup', this.__deletePressListener, true);
      this.__deletePressListener = null;
    }
  }
  delete() {
    this.deleting();
    this.__element.remove();
  }

}
